<div class="ori-footer-element">
  <div class="container ori-footer-wrapper">
    <div class="ori-footer__right">&copy; 2020 ORI Team</div>
  </div>
</div>
